import { styled } from '@material-ui/core/styles';

const Center = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexGrow: 1
})

export default Center;